<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                {{
                  nodeType.id
                    ? $t("nodeType.form.titleEdit")
                    : $t("nodeType.form.titleNew")
                }}
              </div>
            </div>
            <hr style="margin-top: -4px" />
            <div class="col-md-12 pb-2">
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label
                    ><span class="required">*</span>
                    {{ $t("nodeType.form.nameLabel") }}</label
                  >
                  <input
                    type="text"
                    class="form-control"
                    v-model="nodeType.name"
                    placeholder=""
                  />
                </div>
              </div>

              <!-- Editor de campos dinâmicos -->
              <div class="card mt-3">
                <div
                  class="card-header d-flex justify-content-between align-items-center py-2"
                >
                  <span class="font-weight-bold">{{
                    $t("nodeType.form.fieldsEditorTitle")
                  }}</span>
                  <b-button size="sm" variant="success" @click="addField"
                    >+ {{ $t("nodeType.form.addField") }}</b-button
                  >
                </div>
                <div class="card-body p-2">
                  <div
                    v-for="(field, index) in fieldSchema"
                    :key="index"
                    class="border rounded p-2 mb-2 bg-light"
                  >
                    <div class="form-row align-items-end">
                      <div class="form-group col-md-2 mb-1">
                        <label class="small mb-0">{{
                          $t("nodeType.form.keyLabel")
                        }}</label>
                        <input
                          type="text"
                          class="form-control form-control-sm"
                          v-model="field.key"
                          placeholder="ex: cnes"
                        />
                      </div>
                      <div class="form-group col-md-3 mb-1">
                        <label class="small mb-0">{{
                          $t("nodeType.form.fieldLabelLabel")
                        }}</label>
                        <input
                          type="text"
                          class="form-control form-control-sm"
                          v-model="field.label"
                          placeholder="ex: CNES"
                        />
                      </div>
                      <div class="form-group col-md-2 mb-1">
                        <label class="small mb-0">{{
                          $t("nodeType.form.typeLabel")
                        }}</label>
                        <select
                          class="form-control form-control-sm"
                          v-model="field.type"
                          @change="onTypeChange(field)"
                        >
                          <option value="text">{{ $t("nodeType.form.typeText") }}</option>
                          <option value="number">{{ $t("nodeType.form.typeNumber") }}</option>
                          <option value="textarea">{{ $t("nodeType.form.typeTextarea") }}</option>
                          <option value="select">{{ $t("nodeType.form.typeSelect") }}</option>
                        </select>
                      </div>
                      <div class="form-group col-md-2 mb-1">
                        <label class="small mb-0">{{
                          $t("nodeType.form.colLabel")
                        }}</label>
                        <select
                          class="form-control form-control-sm"
                          v-model="field.col"
                        >
                          <option value="col-md-3">3 (25%)</option>
                          <option value="col-md-4">4 (33%)</option>
                          <option value="col-md-6">6 (50%)</option>
                          <option value="col-md-12">12 (100%)</option>
                        </select>
                      </div>
                      <div class="form-group col-md-2 mb-1">
                        <label class="small mb-0">{{
                          $t("nodeType.form.requiredLabel")
                        }}</label>
                        <select
                          class="form-control form-control-sm"
                          v-model="field.required"
                        >
                          <option :value="false">{{ $t("nodeType.form.no") }}</option>
                          <option :value="true">{{ $t("nodeType.form.yes") }}</option>
                        </select>
                      </div>
                      <div class="form-group col-md-1 mb-1 text-right">
                        <label class="small mb-0 d-block">&nbsp;</label>
                        <b-button
                          size="sm"
                          variant="danger"
                          @click="removeField(index)"
                          >✕</b-button
                        >
                      </div>
                    </div>
                    <!-- Opções do select -->
                    <div v-if="field.type === 'select'" class="mt-2">
                      <label class="small mb-1 font-weight-bold">{{
                        $t("nodeType.form.selectOptionsLabel")
                      }}</label>
                      <div
                        v-for="(opt, optIndex) in field.options"
                        :key="optIndex"
                        class="d-flex align-items-center mb-1"
                      >
                        <input
                          type="text"
                          class="form-control form-control-sm mr-1"
                          v-model="field.options[optIndex]"
                          :placeholder="$t('nodeType.form.optionPlaceholder', { n: optIndex + 1 })"
                        />
                        <b-button
                          size="sm"
                          variant="outline-danger"
                          @click="field.options.splice(optIndex, 1)"
                          >✕</b-button
                        >
                      </div>
                      <b-button
                        size="sm"
                        variant="outline-secondary"
                        @click="field.options.push('')"
                        >+ {{ $t("nodeType.form.addOption") }}</b-button
                      >
                    </div>
                  </div>
                  <p v-if="!fieldSchema.length" class="text-muted small mb-0">
                    {{ $t("nodeType.form.noFieldsDefined") }}
                  </p>
                </div>
              </div>

              <div class="row mt-3">
                <div class="col-md-12">
                  <b-button v-if="$hasAbility('node.admin')" variant="primary" @click="save">{{ $t("common.save") }}</b-button>
                  <b-button
                    variant="outline-secondary"
                    class="ml-1"
                    @click="$router.push('/node_types')"
                  >
                    {{ $t("common.cancel") }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BButton } from "bootstrap-vue";

export default {
  components: { BButton },
  data() {
    return {
      nodeType: {
        id: null,
        name: "",
      },
      fieldSchema: [],
    };
  },
  methods: {
    addField() {
      this.fieldSchema.push({
        key: "",
        label: "",
        type: "text",
        required: false,
        col: "col-md-6",
        options: [],
      });
    },

    removeField(index) {
      this.fieldSchema.splice(index, 1);
    },

    onTypeChange(field) {
      if (field.type !== "select") {
        field.options = [];
      }
    },

    save() {
      const self = this;
      self.nodeType.field_schema = self.fieldSchema.length
        ? self.fieldSchema
        : null;

      let api = self.$store.state.api + "node_types";
      if (self.nodeType.id) {
        api += "/" + self.nodeType.id;
        self.nodeType._method = "PUT";
      }

      self.$loading(true);
      self.$http
        .post(api, self.nodeType)
        .then(() => {
          self.$message(
            self.$t("nodeType.messages.saveSuccessTitle"),
            self.$t("nodeType.messages.saveSuccessMessage"),
            "success",
          );
          self.$loading(false);
          self.$router.push("/node_types");
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },

    getNodeType(id) {
      const self = this;
      self.$loading(true);
      self.$http
        .get(self.$store.state.api + "node_types/" + id)
        .then((response) => {
          const data = response.data.data[0];
          self.nodeType = data;
          self.fieldSchema = data.field_schema || [];
          self.$loading(false);
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted() {
    const id = this.$route.params.id;
    if (id) this.getNodeType(id);
  },
};
</script>

<style scoped>
.required {
  color: red;
}
</style>
